export const DISABLED_OUTREACH_ERROR = {
  BROWSER_EXTENSION_NOT_INSTALLED: 'BROWSER_EXTENSION_NOT_INSTALLED',
  LOGGED_OUT: 'LOGGED_OUT',
  UNAVAILABLE: 'UNAVAILABLE',
};
